import noop from 'utils/noop';
import { Checkmark } from 'ui/icons/action/Checkmark';
import { colors } from 'ui/theme/colors';
import { StyledToggle, Wrapper, Indicator } from './Styled';
import { TOGGLE_SIZES } from './constants';

export type ToggleProps = {
  /** Component class name, can be used for overriding styling */
  className?: string;
  /** Whether toggle is active */
  isActive?: boolean;
  /** Whether toggle is disabled */
  isDisabled?: boolean;
  /** Toggle id */
  id?: string;
  /** Id of the label attribute */
  labelId?: string;
  /** Toggle handler that passes in the new `active` value */
  onClick: (isActive?: boolean) => void;
  /** Display a checkmark icon over Indicator when checkmark status is Active */
  showCheckmarkOnActive?: true;
  /** Diameter of toggle switch */
  size?: TOGGLE_SIZES;
  /** Toggle button name */
  name?: string;
};

export const Toggle = ({
  className,
  isActive = false,
  isDisabled = false,
  id,
  name,
  labelId = '',
  onClick = noop,
  showCheckmarkOnActive,
  size = TOGGLE_SIZES.SMALL,
  ...props
}: ToggleProps) => (
  <StyledToggle className={className}>
    <Wrapper
      name={name}
      type="button"
      isActive={isActive}
      aria-checked={isActive}
      aria-labelledby={labelId}
      data-test={`toggle-${id}`}
      disabled={isDisabled}
      id={id}
      onClick={() => onClick(!isActive)}
      role="switch"
      size={size}
      {...props}
    >
      <Indicator isActive={isActive} size={size}>
        {showCheckmarkOnActive && isActive && (
          <Checkmark color={colors.iconSuccess} height="100%" width="60%" />
        )}
      </Indicator>
    </Wrapper>
  </StyledToggle>
);
